/**
 * Úložiště všech podmínek z různých míst,
 * zatím implementováno v paměti, ale časem se to může změnit
 */
export class ConditionStore {
    private static _allConditions: Map<string, string> = new Map<string, string>();
    private static _localEvaluable: Set<string> = new Set();

    /**
     * Vloží podmínku do úložiště
     * @param id identifikátor podmínky
     * @param expression tělo podmínky
     * @param localEvaluable zda lze vyhodnocovat lokálně na klientovi
     */
    public static addCondition(id: string, expression: string, localEvaluable: boolean): void {
        if (localEvaluable)
            ConditionStore._localEvaluable.add(id);

        ConditionStore._allConditions.set(id, expression);
    }

    /**
     * Zjišťuje, zda podmínka lze vyhodnocovat lokálně na klientovi
     * @param id identifikátor podmínky
     */
    public static isLocalEvaluable(id: string): boolean {
        return ConditionStore._localEvaluable.has(id);
    }

    /**
     * Získá tělo podmínky
     * @param id identifikátor podmínky
     */
    public static getCondition(id: string): string | undefined {
        return this._allConditions.get(id);
    }
}
